module.exports = __webpack_public_path__ + "static/img/PSS-80AS.e29373f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/PSS-80AS.png
// module id = ZSt3
// module chunks = 1